import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CreateApiUserResponse } from '../../../api/api-types/user.api';

@Component({
	selector: 'lvr-user-created-dialog',
	template: `
		<h2 mat-dialog-title>Anwender angelegt</h2>
		<mat-dialog-content>
			<p>Der Anwender wurde mit folgenden Daten angelegt:</p>
			<p><strong>Benutzername:</strong> {{ dialogData.userPrincipalName }}</p>
			<p><strong>Initiales Passwort:</strong> {{ dialogData.userPrincipalPassword }}</p>
			<p>Das Passwort muss nach der ersten Anmeldung geändert werden.</p>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button matButton="filled" cdkFocusInitial (click)="dialogRef.close()">OK</button>
		</mat-dialog-actions>
	`,
	imports: [MatDialogModule, MatButton],
})
export class UserCreatedDialog {
	public readonly dialogData = inject<CreateApiUserResponse>(MAT_DIALOG_DATA);
	public readonly dialogRef = inject(MatDialogRef<UserCreatedDialog>);
}
